angular.module('picmonicng').filter('string', function () {
  return function (input) {
    if (input) {
      return input.toString();
    }
  };
});
